import Navbar from "../components/Login/Navbar/Navbar2";
import EditorBody from "../components/Editor/body/Editorbody";

const Editor = () => {
    return(
        <>
            <Navbar />
            <EditorBody />
        </>
    )
}

export default Editor;